<template>
  <div
    class="w-full min-h-screen grid grid-cols-1 md:grid-cols-2 bg-noise bg-grayscale-2"
  >
    <div class="flex flex-col justify-center items-center p-6">
      <img
        src="https://ik.imagekit.io/xposuremusic/full-logo.svg"
        alt="xposure-logo"
      />
      <div class="max-w-sm w-full z-10">
        <ClientOnly>
          <SignUpForm
            @changeAuthType="changeAuthType"
            @userAuthenticated="userAuthenticated"
          />
        </ClientOnly>
      </div>
    </div>
    <div
      class="bg-cover bg-center hidden md:flex items-center justify-center relative text-black bg-[url('https://ik.imagekit.io/xposuremusic/signup-new.png')] overflow-hidden"
    >
      <div class="flex gap-8 flex-col bg-white py-12 px-8 rounded-16">
        <p
          class="font-druk-wide italic uppercase text-center text-xl whitespace-wrap w-60"
        >
          level up your music and career
        </p>
        <div class="leading-6">
          <div v-for="item of listItems" class="flex gap-4 items-center">
            <i class="icon-right" />
            <p>{{ item }}</p>
          </div>
        </div>
      </div>
      <div class="bottom-6 absolute w-full flex flex-col gap-4">
        <p class="text-white text-center">
          Trusted by the best in the industry:
        </p>
        <div class="flex justify-center xl:gap-6">
          <img
            class="h-14 w-14"
            v-for="partner of partners"
            :src="`https://ik.imagekit.io/xposuremusic/studio-icons/${partner}.svg`"
            :alt="partner"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SignUpForm from "@/components/authentication/SignUpForm.vue";
import PageTitles from "../assets/strings";
import { useAuthenticationStore } from "../store/authentication";

const router = useRouter();

useSessionStorage("showHeader", true).value = false;

const changeAuthType = () => {
  router.push("/login");
};

let redirectUrl: string | null = null;

onMounted(() => {
  redirectUrl = localStorage.getItem("redirectAfterSignIn");
});

const userAuthenticated = () => {
  router.push(redirectUrl ?? "/dashboard");
};

if (!process.server) {
  const authStore = useAuthenticationStore();
  const isLogged = computed(() => Boolean(authStore.authUser?.authToken));
  if (isLogged.value) {
    router.push("/dashboard");
  }
}

const partners = [
  "interscope",
  "atlantic",
  "rca",
  "sony-music",
  "warner-music-group",
  "universal-music-group",
  "def-jam",
  "rocnation",
];
const listItems = [
  "Connect directly with pros",
  "Book 1-1 video calls",
  "Request feedback",
  "Submit your music",
  "Apply to opportunities",
  "Network, learn, and grow",
];

useHead({
  title: PageTitles.signup.title,
  meta: [
    {
      name: "description",
      content: PageTitles.signup.description,
    },
    {
      name: "og:description",
      content: PageTitles.signup.description,
    },
    {
      name: "twitter:description",
      content: PageTitles.signup.description,
    },
    {
      property: "og:image",
      content: "https://ik.imagekit.io/xposuremusic/signup_og.png",
    },
    {
      property: "twitter:image",
      content: "https://ik.imagekit.io/xposuremusic/signup_og.png",
    },
    {
      property: "og:image:secure_url",
      content: "https://ik.imagekit.io/xposuremusic/signup_og.png",
    },
    {
      property: "og:image:alt",
      content: PageTitles.signup.title,
    },
    {
      property: "og:image:type",
      content: "image/svg",
    },
    {
      property: "og:image:width",
      content: "512",
    },
    {
      property: "og:image:height",
      content: "512",
    },
    {
      property: "og:title",
      content: PageTitles.signup.title,
    },
    {
      property: "twitter:title",
      content: PageTitles.signup.title,
    },
  ],
});
</script>
